module.exports = __webpack_public_path__ + "static/img/manual_zh_31.b2f146f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_31.png
// module id = JG2U
// module chunks = 4